import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import {
  foodGallery,
  mobileGallery,
  slide1,
  slide2,
  slide3,
  slide4,
  slide5,
  slide6,
} from 'images'
import Slider from 'react-slick'

const settings = {
  infinite: true,
  speed: 500,
  arrows: false,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  cssEase: 'linear',
  pauseOnHover: false,
  draggable: true,
  swipe: true,
}

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <Slider {...{ ...settings, slidesToShow: 1 }}>
          <CFImage
            src={slide1}
            style={{ objectFit: 'contain' }}
            ph="15px"
            pv="10px"
          />
          <CFImage
            src={slide2}
            style={{ objectFit: 'contain' }}
            ph="15px"
            pv="10px"
          />
          <CFImage
            src={slide3}
            style={{ objectFit: 'contain' }}
            ph="15px"
            pv="10px"
          />
        </Slider>
        <Slider {...{ ...settings, slidesToShow: 1 }}>
          <CFImage
            src={slide4}
            style={{ objectFit: 'contain' }}
            ph="15px"
            pv="10px"
          />
          <CFImage
            src={slide5}
            style={{ objectFit: 'contain' }}
            ph="15px"
            pv="10px"
          />
          <CFImage
            src={slide6}
            style={{ objectFit: 'contain' }}
            ph="15px"
            pv="10px"
          />
        </Slider>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center maxWidth="1400px" w="100%" mt="-1px">
          <CFImage src={foodGallery} alt="Food Gallery" w="100%" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
